var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFichaTecnicaWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ficha_tecnica_white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.773,
    height: 46.428,
    viewBox: "0 0 34.773 46.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5f5f5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-1",
    d: "M457.2,264.645V256h-.1a1.36,1.36,0,0,0-.962.4L447.4,265.14a1.36,1.36,0,0,0-.4.962v.1h8.645a1.556,1.556,0,0,0,1.554-1.554Zm0,0",
    transform: "translate(-447 -256)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-1",
    d: "M477.5,256h-17.58v8.645a4.279,4.279,0,0,1-4.274,4.274H447v29.235a4.279,4.279,0,0,0,4.274,4.274H477.5a4.272,4.272,0,0,0,4.274-4.274v-37.88A4.272,4.272,0,0,0,477.5,256Zm-19.9,23.709a1.36,1.36,0,0,1,1.924,0l3.506,3.506v-9.828a1.36,1.36,0,1,1,2.72,0v9.828l3.506-3.506a1.36,1.36,0,0,1,1.923,1.923l-5.828,5.828a1.36,1.36,0,0,1-1.923,0l-5.828-5.828a1.36,1.36,0,0,1,0-1.923Zm12.617,13.977H458.559a1.36,1.36,0,0,1,0-2.72h11.655a1.36,1.36,0,0,1,0,2.72Zm0,0",
    transform: "translate(-447 -256)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFichaTecnicaWhite);
export default __webpack_public_path__ + "static/media/ficha_tecnica_white.464abfa6d69d5556ddb53ba16c008339.svg";
export { ForwardRef as ReactComponent };